import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import NavOptions from "../nav-options/nav-options.component";

import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaExchangeAlt,
} from "react-icons/fa";
import "./drop-menu.styles.scss";

const mapStateToProps = (state) => ({
  showMenu: state.menu.showMenu,
});

const getPathWithLang = (pathname, targetLang) => {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) {
    return `/${targetLang}`;
  }

  if (segments[0] === "en" || segments[0] === "zh") {
    segments[0] = targetLang;
    return `/${segments.join("/")}`;
  }

  return `/${targetLang}/${segments.join("/")}`;
};

const DropMenu = ({ showMenu }) => {
  const history = useHistory();
  const location = useLocation();
  const { i18n } = useTranslation();

  const currentLang = i18n.language.startsWith("zh") ? "zh" : "en";
  const targetLang = currentLang === "zh" ? "en" : "zh";

  const handleLanguageToggle = () => {
    const nextPath = getPathWithLang(location.pathname, targetLang);
    i18n.changeLanguage(targetLang);
    history.push(nextPath);
  };

  return (
    <div className={`drop-menu ${showMenu ? "show" : "hide"}`}>
      <div className="drop-menu-content">
        <NavOptions vertical inverted show />
        <div className="icon-set">
          <a
            className="icon"
            href="https://www.instagram.com/toofareastbarber/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Too Far East Barber's Instagram page"
          >
            <FaInstagramSquare />
          </a>
          <a
            className="icon"
            href="https://www.facebook.com/toofareastbarber/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Too Far East Barber's Facebook page"
          >
            <FaFacebookSquare />
          </a>
        </div>
        <button
          className="lang-toggle"
          type="button"
          onClick={handleLanguageToggle}
        >
          <FaExchangeAlt className="lang-toggle-icon" aria-hidden="true" />
          {targetLang === "zh" ? "中文" : "EN"}
        </button>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(DropMenu);
